export function useSendDebugLogs() {
    return {
        sendLogs: () => {},
        isPending: false,
    }
}
